import PromoList from './index.styles';

export default PromoList;
